import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaGithub, FaPaypal, FaRegHandPeace } from "react-icons/fa";

export default function AboutPage() {
  const { t } = useTranslation();

  // "about": {
  //   "title": "Meet the KokoFin Team",
  //   "tagline": "Built with 🍃 by expense-weary humans",
  //   "ourStory": {
  //     "title": "Our Story",
  //     "content1": "KokoFin started as a frustration-fueled side project between RainZ and a group of friends tired of manual expense tracking. As freelancers ourselves, we wanted to create a solution that felt more like helpful companion than accounting software.",
  //     "content2": "What began as a simple receipt scanner evolved into a full AI-powered platform, with our koala mascot Koko becoming the heart of our user experience. We're proud to serve over 50,000 users while maintaining our core values of privacy and approachability.",
  //     "quote": "No spreadsheets, no data selling, just helpful koala magic!"
  //   },
  //   "ourMission": {
  //     "title": "Our Mission",
  //     "subtitle1": "Democratize Financial Tools",
  //     "content1": "Make advanced financial insights accessible to everyone through AI, not accounting degrees",
  //     "subtitle2": "Privacy First",
  //     "content2": "Prove that useful AI can exist without exploiting user data"
  //   },
  //   "team": {
  //     "title": "The Humans Behind the Koala",
  //     "roles": {
  //       "lead": "Founder & Chief Leaf Muncher"
  //     },
  //     "bios": {
  //       "rainz": "Full-stack developer with 8+ years experience, passionate about ethical AI"
  //     }
  //   },
  //   "viewCode": "View Our Code",
  //   "supportUs": "Support Our Work"
  // },
  return (
    <Container className="py-5 about-page">
      <Row className="mb-5">
        <Col md={8} className="mx-auto text-center">
          <h1 className="display-4 mb-4">
            {t("about.title")} 🐨
            <span className="text-muted fs-2 d-block mt-2">{t("about.tagline")}</span>
          </h1>
        </Col>
      </Row>

      <Section title={t("about.ourStory.title")} icon="📖">
        <p>{t("about.ourStory.content1")}</p>
        <p>{t("about.ourStory.content2")}</p>
        <blockquote className="blockquote koala-quote">
          <FaRegHandPeace className="me-2" />
          {t("about.ourStory.quote")}
        </blockquote>
      </Section>

      <Section title={t("about.ourMission.title")} icon="🎯">
        <Row>
          <Col md={6}>
            <h5>{t("about.ourMission.subtitle1")}</h5>
            <p>{t("about.ourMission.content1")}</p>
          </Col>
          <Col md={6}>
            <h5>{t("about.ourMission.subtitle2")}</h5>
            <p>{t("about.ourMission.content2")}</p>
          </Col>
        </Row>
      </Section>

      <Section title={t("about.team.title")} icon="👋">
        <Row className="g-4">
          <Col md={4}>
            <TeamMember
              name="RainZ"
              role={t("about.team.roles.lead")}
              bio={t("about.team.bios.rainz")}
              image="/rainz-avatar.jpg"
            />
          </Col>
          {/* Add more team members */}
        </Row>
        <div className="mt-4 text-center">
          <a href="https://github.com/your-repo" target="_blank" rel="noopener" className="btn btn-outline-dark me-2">
            <FaGithub className="me-2" />
            {t("about.viewCode")}
          </a>
          <a href="https://www.paypal.com/ncp/payment/F4KK4RCLJH3SC" className="btn btn-primary">
            <FaPaypal className="me-2" />
            {t("about.supportUs")}
          </a>
        </div>
      </Section>
    </Container>
  );
}

const Section = ({ title, icon, children }) => (
  <section className="mb-5">
    <h2 className="mb-4">
      <span className="me-2">{icon}</span>
      {title}
    </h2>
    {children}
  </section>
);

const TeamMember = ({ name, role, bio, image }) => (
  <Card className="h-100 shadow-sm">
    <Image src={image} alt={name} className="card-img-top" />
    <Card.Body>
      <h5>{name}</h5>
      <small className="text-muted d-block mb-2">{role}</small>
      <p className="text-muted">{bio}</p>
    </Card.Body>
  </Card>
);
